import { FieldCallback, useField } from '@area2k/use-form';
import { ComponentProps, useEffect, useRef } from 'react';

import FormElement from '@/components/FormElement';
import Option from '@/components/Option';

type OptionProps = Omit<
  ComponentProps<typeof Option>,
  'id' | 'value' | 'onChange' | 'defaultValue'
>;

type Props = OptionProps & {
  fieldId: string;
  label?: string;
  callback?: FieldCallback<boolean>;
  defaultValue?: boolean;
};

const OptionField = ({
  fieldId,
  label,
  callback = () => {},
  defaultValue,
  ...props
}: Props) => {
  const { value, setValue } = useField<boolean>(fieldId, callback);
  const hasSetInitialValue = useRef(false);

  // Set default value on mount if provided
  useEffect(() => {
    if (defaultValue !== undefined && !hasSetInitialValue.current) {
      setValue(defaultValue);
      hasSetInitialValue.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);

  return (
    <FormElement>
      <Option
        type="checkbox"
        {...props}
        checked={value}
        id={fieldId}
        label={label}
        name={fieldId}
        onChange={(ev) => setValue(ev.currentTarget.checked)}
      />
    </FormElement>
  );
};

export default OptionField;
